import { castArray, merge } from 'lodash';

export const getInitialValueOnBoolean = (value) => value.toString();

export const getInitialValue = (value, attributeType) => {
  if (attributeType === 'decimal') {
    return value;
  }

  if (attributeType === 'select') {
    return castArray(value).filter(Boolean);
  }

  if (attributeType === 'double_select') {
    const newValue = merge({}, value);

    if (!newValue.root_value) {
      newValue.root_value = '';
    }
    if (!newValue.child_value) {
      newValue.child_value = [];
    }

    return newValue;
  }

  if (attributeType === 'boolean') {
    return value;
  }

  return (
    (typeof value === 'boolean' ? getInitialValueOnBoolean(value) : value) || ''
  );
};

export const customAttributesInitialValues = (customAttributes = []) => {
  const initialValues = {};

  customAttributes.forEach(
    ({ name, value, attribute_type: attributeType }) =>
      (initialValues[name] = getInitialValue(value, attributeType)),
  );

  return initialValues;
};
